<template>
    <div id="startPage" :style="defaultHeight">
        <div class="headerMain">
            <div class="top_logo inlineRight">
                <img :src="logoImg" alt="logo"/>
            </div>
            <div class="right_box inlineRight text-right">
                <div>
                    <div class="customButton">
                        <div class="username">{{ userName }}</div>
                        <div class="userImg"><img :src="userImg" alt="exit" height="100%"/></div>
                    </div>
                    <div class="customButton" @click="changePsw">
                        <div class="username">修改密码</div>
                        <div class="iconImg"><img :src="pswImg" height="100%"/></div>
                    </div>
                    <div class="customButton" @click="logout">
                        <div class="username">退出</div>
                        <div class="iconImg"><img :src="exitImg" alt="exit" height="100%"/></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="menuF" v-if="showMenu">
            <div class="menuS" v-for="(item,i) in firstName" :style="{width:menuWidth}">
                <div class="menuT" style="margin-top: 50%">
                    <div class="menuA" @click="clickMenu(item.name)">
                        {{ item.name }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {globalConfig} from "../../static/config";

export default {
    data() {
        return {
            firstName: [
                {'name': '全日制'},
                {'name': '职后教育'},
                {'name': '其他'},
            ],
            menuWidth: '',
            showMenu: true,
            menuName: '',
            defaultHeight: {
                height: "", //判断中间内容的高度
                background: '',
            },
            logoImg: require("image/homePage/logo.png"), //logo
            userImg: require('image/homePage/userImg.png'), //用户标签
            pswImg: require('image/homePage/pswImg.png'), //用户标签
            exitImg: require("image/homePage/exitImg.png"), //退出
            userName: '',
        }
    },
    mounted() {
        this.menuWidth = 100 / this.firstName.length + "%";
        window.addEventListener("resize", this.getHeight);
        this.getHeight();
        this.queryUserInfo();
    },
    methods: {
        logout() {
            this.$api.system.basic.userLogout({}).then((res) => {
                if (res.status == 200) {
                    localStorage.clear();
                    if (globalConfig.CASSWITCH) {
                        window.open(globalConfig.CASURL + '/logout?service=' + encodeURIComponent(globalConfig.DOMIN), '_self');
                    } else {
                        location.reload();
                    }
                } else {
                    this.$message.error('登出失败，网络异常');
                }
            }).catch((err) => {
                console.log(err);
                this.$message.error('登出失败，网络异常');
            });
        },
        changePsw() {
            window.open(globalConfig.PSWURL, '_self');
        },
        queryUserInfo() {
            this.$api.system.basic.userInfo({}).then((res) => {
                const userInfo = res.data.data;
                if (userInfo) {
                    this.userName = userInfo.name;
                } else {
                }
            }).catch((err) => {
                console.log(err);
            });
        },
        clickMenu(name) {
            this.showMenu = false;
            this.menuName = name;
            var queryName = '';
            switch (name) {
                case '全日制':
                    queryName = 'fullTime';
                    break;
                case '职后教育':
                    queryName = 'education';
                    break;
                case '其他':
                    queryName = 'other';
                    break;
                default:
                    break;
            }
            this.$router.push({path: '/homePage', query: {'name': queryName}});
        },
        returnMenu() {
            this.showMenu = true;
            this.menuName = '';
        },
        getHeight() {
            if ($(window).width() < 750) {
                this.defaultHeight.height = window.innerHeight + "px";
                this.defaultHeight.background = 'url(' + require('image/homePage/newsBg.jpg') + ') no-repeat  center';
            } else {
                this.defaultHeight.height = window.innerHeight + "px";
                this.defaultHeight.background = 'url(' + require('image/homePage/newsBg.jpg') + ') no-repeat';
            }
        },
    }
};
</script>
<style lang="scss">
#startPage {
    //height: 100vh;
    //width: 100%;
    // border: 1px red solid;
    //overflow: hidden;
    //background: url(../../assets/images/sp-bg.png) no-repeat center;
    //background-size: cover;
    //position: relative;
}

/* 返回原始菜单界面 */
#startPage .backMenu {
    height: 50px;
    padding: 8px 15px;
    float: right;
}

#startPage .backMenu img:hover {
    cursor: pointer;
}

/* 第一层定位 */
#startPage .menuF {
    //height: 50%;
    //width: 100%;
    //position: absolute;
    //top: 25%;
    //left: 0;
}

/* 第二层宽度 */
#startPage .menuF .menuS {
    display: inline-block;
    float: left;
    height: 100%;
    padding: 10px;
}

/* 第三层内容 */
#startPage .menuF .menuS .menuT {
    height: 100%;
    position: relative;
}

// 第一层菜单
#startPage .menuA {
    height: 20vh;
    line-height: 18vh;
    font-size: 2.5vh;
    border-radius: 8px;
    letter-spacing: 5px;
    background: rgba(255, 255, 255, 0.3);
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    padding: 10px;
    text-align: center;
    position: absolute;
    width: 100%;
    z-index: 0;
}

#startPage .menuB {
    display: none;
}

#startPage .menuA:hover {
    border-radius: 30% 8px;
    cursor: pointer;
}

#startPage .openTwoList .menuA:hover {
    border-radius: 8px;
}

// 点击后显示二层菜单
.openTwoList {
    height: 100%;
}

#startPage .openTwoList .menuT {
    border-radius: 8px;
    letter-spacing: 5px;
    background: rgba(255, 255, 255, 0.3);
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    padding: 10px;
}

#startPage .openTwoList .menuA {
    background: transparent;
    box-shadow: none;
    backdrop-filter: none;
    position: initial;
    height: 5vh;
    line-height: 3vh;
    border-radius: 0;
    font-size: 2.2vh;
    border-bottom: 2px #238923 solid;
}

// 展开菜单内容
#startPage .openTwoList .menuB {
    display: block;
    z-index: 1;
    height: 90%;
    padding: 10px;
}

// 左侧tab
#startPage .openTwoList .menuB .el-tabs__item.is-active {
    color: #238923 !important;
}

#startPage .openTwoList .menuB .el-tabs__active-bar {
    background-color: #238923;
}

#startPage .openTwoList .menuB .el-tabs__item {
    // font-weight: bold;/
    font-size: 1.8vh;
}

#startPage .openTwoList .menuB .el-tabs--left,
#startPage .openTwoList .menuB .el-tabs--right,
#startPage .openTwoList .menuB .el-tabs__content {
    height: 100% !important;
}

// 右侧菜菜单名称
#startPage .openTwoList .menuB .menuTwoNameBox {
    display: inline-block;
    float: left;
    width: 50%;
    height: 8vh;
    line-height: 6vh;
    text-align: center;
    padding: 1vh;
}

#startPage .openTwoList .menuB .menuTwoName {
    font-size: 1.7vh;
    border: 1px #dadada solid;
    border-radius: 5px;
}

#startPage .openTwoList .menuB .menuTwoName:hover {
    cursor: pointer;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

// 弹框
#openMsg {
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    left: 0;
    top: 0;
    z-index: 9;
    display: none;
}

#openMsg .openBox {
    position: absolute;
    width: 500px;
    height: 150px;
    top: calc(50% - 70px);
    left: calc(50% - 250px);
    background-color: #fff;
    border-radius: 5px;
}

// 弹框上半部分
#openMsg .openTop {
    height: 4vh;
    border-bottom: 1px #dadada solid;
}

#openMsg .closeOpenMsg {
    display: inline-block;
    height: 100%;
    padding: 0 10px;
    font-size: 2vh;
    line-height: 3.5vh;
    float: right;
}

#openMsg .closeOpenMsg:hover {
    color: #238923;
    cursor: pointer;
    font-weight: bold;
}

// 弹框下半部分
#openMsg .openMain {
    height: 65%;
    padding-top: 2vh;
}

#openMsg .openList {
    display: inline-block;
    float: left;
    padding: 10px;
    width: 33.3%;
    line-height: 35px;
    text-align: center;
}
</style>

<style>
#startPage {
    width: 100%;
    height: 100%;
    margin: 0;
    overflow: hidden;
}

#startPage .inlineRight {
    display: inline-block;
    float: left;
}

.text-center {
    text-align: center;
}

.text-right {
    text-align: right;
}

/*--------------------------------------- 头部 ---------------------------------------*/
#startPage .headerMain {
    height: 100px;
    position: relative;
    background-color: #2f79c4;
    z-index: 2;
}

/* logo区域 */
#startPage .headerMain .top_logo {
    height: 100%;
    width: 40%;
    padding: 8px 0 8px 10px;
}

#startPage .headerMain .top_logo img {
    height: 90%;
    margin-top: 5px;
}

/* 右侧用户名区域 */
#startPage .headerMain .right_box {
    height: 100%;
    width: 60%;
    color: #fff;
}

#startPage .headerMain .right_box div {
    height: 100%;
    position: relative;
}

#startPage .headerMain .right_box .userImg {
    height: 50px;
    background: #fff;
    border-radius: 50%;
    padding: 8px;
    margin-right: 7px;
    float: right;
    top: 50%;
    transform: translateY(-50%);
}

#startPage .headerMain .right_box .username {
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    margin-right: 10px;
    float: right;
    top: 50%;
    transform: translateY(-50%);
}

#startPage .headerMain .right_box .iconImg {
    height: 50px;
    padding: 8px;
    margin-right: 15px;
    cursor: pointer;
    float: right;
    top: 50%;
    transform: translateY(-50%);
}

/*--------------------------------------- 中心 ---------------------------------------*/
#startPage .mainMain {
    background-size: cover !important;
    position: relative;
}

#startPage .phoneBox {
    display: none;
}

/* 背景 */
#startPage .mainMain .mainBg {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
}

#startPage .mainMain .mainBg .topbg {
    height: 50%;
    background: #f5f6f0;
    position: relative;
}

#startPage .mainMain .mainBg .topbg img {
    position: absolute;
    bottom: 0;
}

#startPage .mainMain .mainBg .titleBg {
    position: absolute;
    bottom: 0;
}

/* 内容 */
#startPage .mainMain .mainNr {
    z-index: 2;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
}

/* 走马灯高度 */
#startPage .mainMain .mainNr .el-carousel--horizontal,
#startPage .mainMain .mainNr .el-carousel__container {
    height: 100%;
}

/* 左右箭头 */
#startPage .mainMain .mainNr .el-carousel__arrow {
    background: transparent;
    height: auto;
    width: auto;
}

#startPage .mainMain .mainNr .el-carousel__arrow i:hover {
    color: #ABCAEB;
}

#startPage .mainMain .mainNr .el-carousel__arrow i {
    font-size: 7em;
    color: #6da1d6;
}

/* 指示器 */
#startPage .mainMain .mainNr .el-carousel__indicator--horizontal button {
    width: 50px;
    height: 10px;
    border-radius: 5px;
    background: #ABCAEB;
}

#startPage .mainMain .mainNr .el-carousel__indicator--horizontal.is-active button {
    width: 80px;
    height: 10px;
    background: #2f79c4;
}

#startPage .mainMain .mainNr .itemOne {
    padding: 4em 7em;
}

#startPage .mainMain .card-box {
    height: 100%;
    width: 100%;
}

#startPage .mainMain .cardBg {
    width: 25%;
    height: 33.3%;
    padding: 1em;
}

#startPage .mainMain .cardMain {
    height: 100%;
    width: 100%;
    border-radius: 15px;
    background-color: rgba(255, 255, 255, 0.8);
    box-shadow: 0 0 10px #e0e0e0;
}

#startPage .mainMain .cardMain:hover {
    cursor: pointer;
    transform: translateY(-5px);
}

.mainMain .cardMain .cardImg {
    height: 65%;
    text-align: center;
}

#startPage .mainMain .cardMain .cardImg img {
    height: 90%;
    margin-top: 5%;
}

#startPage .mainMain .cardMain .cardName h3 {
    margin: 0;
    padding: 10px 5px;
    color: #6da1d6;
    font-size: 2vh;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    display: inline-block;
}

#startPage .mainMain .cardMain .cardName small {
    overflow: hidden;
    padding: 0 5px;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    display: inline-block;
    color: #b3b3b3;
}

/*--------------------------------------- 页脚 ---------------------------------------*/
#startPage .footerMain {
    background-color: #2f79c4;
    line-height: 60px;
    height: 60px;
    text-align: center;
    z-index: 2;
}

#startPage .footerMain {
    color: #fff;
}

/*--------------------------------------- 响应式 ---------------------------------------*/
@media all and (min-width: 750px) and (max-width: 1000px) {
    #startPage .mainMain .cardBg {
        width: 33.3%;
        height: 25%;
    }

    #startPage .mainMain .cardMain .cardImg {
        height: 55%;
    }
}

/*------------------- 高度不够缩小图片 -------------------*/
@media all and (max-height: 1000px) {
    .mainMain .cardMain .cardImg {
        height: 55%;
    }
}

/*------------------- 手机端 -------------------*/
@media all and (max-width: 750px) {

    /* 隐藏pc */
    #startPage .pcBox {
        display: none;
    }

    /* 头部 */
    #startPage .headerMain {
        height: 120px;
    }

    #startPage .headerMain .top_logo {
        height: 68px;
        width: 100%;
        text-align: center;
    }

    #startPage .headerMain .right_box {
        height: 36px;
        width: 100%;
        margin-top: 10px;
    }

    #startPage .headerMain .right_box div {
        height: 36px;
    }

    #startPage .headerMain .right_box .username {
        height: 36px;
        line-height: 36px;
    }

    #startPage .headerMain .right_box .userImg {
        height: 36px;
    }

    #startPage .headerMain .right_box .iconImg {
        height: 36px;
    }

    /* 显示手机端 */
    #startPage .phoneBox {
        display: block;
        height: 100%;
        width: 100%;
        /* border:1px red solid; */
        overflow-x: hidden;
        overflow-y: auto;
    }

    #startPage .mainMain .cardBg {
        width: 33.3%;
        height: 180px;
        padding: 8px;
    }

    #startPage .mainMain .cardMain .cardImg {
        height: 50%;
    }
}

@media all and (max-width: 400px) {
    #startPage .headerMain .top_logo img {
        width: 100%;
        height: auto;
    }
}

.customButton {
    display: inline-block;
    cursor: pointer;
}

.customButton:hover {
    color: #ff6146;
}

.customButton .iconImg {
    margin-right: 0 !important;
}
</style>



// WEBPACK FOOTER //
// firstPage.vue?151a3972